"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.credentialFactory = void 0;
const Factory = require("factory.ts");
const credential_definition_factory_1 = require("./credential-definition.factory");
exports.credentialFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    classification: 'Club',
    name: null,
    status: null,
    code: null,
    credential_definition: credential_definition_factory_1.credentialDefinitionFactory.build(),
    credential_tags: []
});
